var React = require('react');

function Unlock (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M72 256V153.5C72 69.5 139.5.3 223.5 0S376 68 376 152v16a23.94 23.94 0 0 1-24 24h-32a23.94 23.94 0 0 1-24-24v-16a72.11 72.11 0 0 0-72.7-72c-39.6.4-71.3 33.3-71.3 72.9V256z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M400 512H48a48 48 0 0 1-48-48V304a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48v160a48 48 0 0 1-48 48z","className":"fa-primary","key":2})]);
}

Unlock.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Unlock;

Unlock.default = Unlock;
